export interface PerformanceChartExtraSettings {
  chartHeight: number;
  showLegend: boolean;
  xAxisType: 'category' | 'datetime';
  axisMin?: number;
  axisMax?: number;
  labelRotation: number;
  endpointTicksOnly: boolean;
}

export const CURRENCY_DISPLAY_THRESHOLD = 100;

export const DEFAULT_PERFORMANCE_CHART_EXTRA_SETTINGS: PerformanceChartExtraSettings = {
  chartHeight: 350,
  showLegend: true,
  xAxisType: 'category',
  labelRotation: -90,
  endpointTicksOnly: false,
};
